import React from 'react';
import _ from 'lodash';
import SparePartsFinderCheckboxListFilter from './SparePartsFinderCheckboxListFilter';

export default class SparePartsFinderCheckboxListMultiSelectFilter extends SparePartsFinderCheckboxListFilter {

    onChange = value => {
        const model = _.xor(this.props.model, [value]);
        this.props.onFilterChange(this.props.meta.slug, model);
    }

    onClearClick = e => this.props.onFilterChange(this.props.meta.slug, this.clear());

    clear = () => [];

    onSelectAllClick = e => this.props.onFilterChange(this.props.meta.slug, this.props.items.map(x => x.value))

    isChecked = o => this.props.selectedValues.includes(o.value);

    canRenderClearOption() {
        return this.props.selectedValues.length > 0;
    }
} 